export default __webpack_public_path__ + "static/media/slack-round.3474c14d.svg";